"use strict";

exports.__esModule = true;
var _DeviceMetricColorSource = require("./DeviceMetricColorSource");
Object.keys(_DeviceMetricColorSource).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceMetricColorSource[key]) return;
  exports[key] = _DeviceMetricColorSource[key];
});